import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Lock, Edit3, Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { API } from "@/utils/constants";

export const EditLoginDialog = ({ open, onClose, onLogin }) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showPwd, setShowPwd] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    
    try {
      const response = await axios.post(`${API}/auth`, { password });
      if (response.data.success) {
        onLogin(password);
        onClose();
        toast.success('Edit mode enabled');
      }
    } catch (err) {
      setError("Invalid password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-[#605e5e] text-center">
            Enable Edit Mode
          </DialogTitle>
          <DialogDescription className="text-sm text-[#8d8b8b] text-center mt-1">
            Enter password to make changes to the rota
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="edit-password" className="text-[#605e5e]">Password</Label>
            <div className="relative">
              <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#8d8b8b]" />
              <Input
                id="edit-password"
                type={showPwd ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-10 pr-10 border-[#e5e7eb] focus:ring-[#605e5e] focus:border-[#605e5e]"
                placeholder="Enter password"
                data-testid="edit-password-input"
              />
              <button
                type="button"
                onClick={() => setShowPwd(!showPwd)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8d8b8b] hover:text-[#605e5e] transition-colors"
                tabIndex={-1}
                data-testid="edit-toggle-pwd"
              >
                {showPwd ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
            {error && <p className="text-red-500 text-sm">{error}</p>}
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button 
              type="submit" 
              className="bg-[#605e5e] hover:bg-[#4b4a4a] text-white"
              disabled={loading}
              data-testid="edit-login-submit-btn"
            >
              {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Edit3 className="h-4 w-4 mr-2" />}
              Enable Editing
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
